import { render, staticRenderFns } from "./PollContent.vue?vue&type=template&id=906dc130"
import script from "./PollContent.vue?vue&type=script&lang=js"
export * from "./PollContent.vue?vue&type=script&lang=js"
import style0 from "./PollContent.vue?vue&type=style&index=0&id=906dc130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports